import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ptBR from './pt-BR';
import enUS from './en-US';
import esBase from './locales/es-base';
import esUYOverride from './locales/overrides/es-UY';
import esPYOverride from './locales/overrides/es-PY';
import esAROverride from './locales/overrides/es-AR';
import esCLOverride from './locales/overrides/es-CL';

function deepMerge(target: any, source: any): any {
  const output = { ...target };
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, { [key]: source[key] });
        else output[key] = deepMerge(target[key], source[key]);
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}

function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

const esUY = deepMerge(esBase, esUYOverride);
const esPY = deepMerge(esBase, esPYOverride);
const esAR = deepMerge(esBase, esAROverride);
const esCL = deepMerge(esBase, esCLOverride);

const resources = {
  'pt-BR': { translation: ptBR },
  'es-UY': { translation: esUY },
  'es-PY': { translation: esPY },
  'es-AR': { translation: esAR },
  'es-CL': { translation: esCL },
  'en-US': { translation: enUS },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'pt-BR',
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
